export default "__VITE_PUBLIC_ASSET__d2b7d6ae__"